// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ListAdminOrganizations200Response,
  ListAdminRegions200Response,
  MarkRegionAvailable200Response,
  SetGlobalPreRelease200Response,
  SetGlobalPreReleaseRequest,
  SetRegionalPreRelease200Response,
  SetRegionalPreReleaseRequest,
} from '../models/index';
import {
  ErrorResponseFromJSON,
  ErrorResponseToJSON,
  ListAdminOrganizations200ResponseFromJSON,
  ListAdminOrganizations200ResponseToJSON,
  ListAdminRegions200ResponseFromJSON,
  ListAdminRegions200ResponseToJSON,
  MarkRegionAvailable200ResponseFromJSON,
  MarkRegionAvailable200ResponseToJSON,
  SetGlobalPreRelease200ResponseFromJSON,
  SetGlobalPreRelease200ResponseToJSON,
  SetGlobalPreReleaseRequestFromJSON,
  SetGlobalPreReleaseRequestToJSON,
  SetRegionalPreRelease200ResponseFromJSON,
  SetRegionalPreRelease200ResponseToJSON,
  SetRegionalPreReleaseRequestFromJSON,
  SetRegionalPreReleaseRequestToJSON,
} from '../models/index';

export interface MarkRegionAvailableRequest {
  cloudProvider: string;
  regionId: string;
}

export interface RemoveGlobalPreReleaseRequest {
  organizationId: string;
}

export interface RemoveRegionalPreReleaseRequest {
  organizationId: string;
  cloudProvider: string;
  regionId: string;
}

export interface SetGlobalPreReleaseOperationRequest {
  organizationId: string;
  setGlobalPreReleaseRequest: SetGlobalPreReleaseRequest;
}

export interface SetRegionalPreReleaseOperationRequest {
  organizationId: string;
  cloudProvider: string;
  regionId: string;
  setRegionalPreReleaseRequest: SetRegionalPreReleaseRequest;
}

/**
 *
 */
export class AdminApi extends runtime.BaseAPI {
  /**
   * Returns one row per organization that holds global and/or per-region pre-release access — the two scopes are independent, so a row may show both at once. Requires a Neo4j employee Okta token.
   * List every organization with pre-release access.
   */
  async listAdminOrganizationsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ListAdminOrganizations200Response>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/organizations`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ListAdminOrganizations200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns one row per organization that holds global and/or per-region pre-release access — the two scopes are independent, so a row may show both at once. Requires a Neo4j employee Okta token.
   * List every organization with pre-release access.
   */
  async listAdminOrganizations(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ListAdminOrganizations200Response> {
    const response = await this.listAdminOrganizationsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Returns the full region catalogue — including regions not yet promoted to general availability — for admin tooling. Requires a Neo4j employee Okta token.
   * List every known region, regardless of availability.
   */
  async listAdminRegionsRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ListAdminRegions200Response>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/regions`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ListAdminRegions200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Returns the full region catalogue — including regions not yet promoted to general availability — for admin tooling. Requires a Neo4j employee Okta token.
   * List every known region, regardless of availability.
   */
  async listAdminRegions(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ListAdminRegions200Response> {
    const response = await this.listAdminRegionsRaw(initOverrides);
    return await response.value();
  }

  /**
   * Marks a region as available to customers. Idempotent — marking an already-available region available again is a no-op. There is no corresponding \"unmark\" action. Requires a Neo4j employee Okta token.
   * Promote a region to general availability.
   */
  async markRegionAvailableRaw(
    requestParameters: MarkRegionAvailableRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<MarkRegionAvailable200Response>> {
    if (requestParameters['cloudProvider'] == null) {
      throw new runtime.RequiredError(
        'cloudProvider',
        'Required parameter "cloudProvider" was null or undefined when calling markRegionAvailable().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling markRegionAvailable().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/regions/{cloud_provider}/{region_id}/mark-available`;
    urlPath = urlPath.replace(
      `{${'cloud_provider'}}`,
      encodeURIComponent(String(requestParameters['cloudProvider'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      MarkRegionAvailable200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Marks a region as available to customers. Idempotent — marking an already-available region available again is a no-op. There is no corresponding \"unmark\" action. Requires a Neo4j employee Okta token.
   * Promote a region to general availability.
   */
  async markRegionAvailable(
    requestParameters: MarkRegionAvailableRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<MarkRegionAvailable200Response> {
    const response = await this.markRegionAvailableRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Idempotent — revoking an organization that isn\'t (or is no longer) enrolled is not an error. Requires a Neo4j employee Okta token.
   * Revoke an organization\'s global pre-release access.
   */
  async removeGlobalPreReleaseRaw(
    requestParameters: RemoveGlobalPreReleaseRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling removeGlobalPreRelease().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/organizations/{organization_id}/global-pre-release`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Idempotent — revoking an organization that isn\'t (or is no longer) enrolled is not an error. Requires a Neo4j employee Okta token.
   * Revoke an organization\'s global pre-release access.
   */
  async removeGlobalPreRelease(
    requestParameters: RemoveGlobalPreReleaseRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.removeGlobalPreReleaseRaw(requestParameters, initOverrides);
  }

  /**
   * Idempotent — revoking a grant that isn\'t (or is no longer) present is not an error. Requires a Neo4j employee Okta token.
   * Revoke an organization\'s early access to one specific region.
   */
  async removeRegionalPreReleaseRaw(
    requestParameters: RemoveRegionalPreReleaseRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling removeRegionalPreRelease().',
      );
    }

    if (requestParameters['cloudProvider'] == null) {
      throw new runtime.RequiredError(
        'cloudProvider',
        'Required parameter "cloudProvider" was null or undefined when calling removeRegionalPreRelease().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling removeRegionalPreRelease().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/organizations/{organization_id}/regional-pre-release/{cloud_provider}/{region_id}`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'cloud_provider'}}`,
      encodeURIComponent(String(requestParameters['cloudProvider'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Idempotent — revoking a grant that isn\'t (or is no longer) present is not an error. Requires a Neo4j employee Okta token.
   * Revoke an organization\'s early access to one specific region.
   */
  async removeRegionalPreRelease(
    requestParameters: RemoveRegionalPreReleaseRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.removeRegionalPreReleaseRaw(requestParameters, initOverrides);
  }

  /**
   * Global scope — the organization sees every supported-but-unavailable region. Idempotent — setting an already-enrolled organization updates its note. `created_by` is taken from the caller\'s own authenticated identity, not the request body. Requires a Neo4j employee Okta token.
   * Enroll an organization for global pre-release access.
   */
  async setGlobalPreReleaseRaw(
    requestParameters: SetGlobalPreReleaseOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SetGlobalPreRelease200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling setGlobalPreRelease().',
      );
    }

    if (requestParameters['setGlobalPreReleaseRequest'] == null) {
      throw new runtime.RequiredError(
        'setGlobalPreReleaseRequest',
        'Required parameter "setGlobalPreReleaseRequest" was null or undefined when calling setGlobalPreRelease().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/organizations/{organization_id}/global-pre-release`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SetGlobalPreReleaseRequestToJSON(
          requestParameters['setGlobalPreReleaseRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      SetGlobalPreRelease200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Global scope — the organization sees every supported-but-unavailable region. Idempotent — setting an already-enrolled organization updates its note. `created_by` is taken from the caller\'s own authenticated identity, not the request body. Requires a Neo4j employee Okta token.
   * Enroll an organization for global pre-release access.
   */
  async setGlobalPreRelease(
    requestParameters: SetGlobalPreReleaseOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SetGlobalPreRelease200Response> {
    const response = await this.setGlobalPreReleaseRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Per-region scope — the organization sees only this one region while it\'s pre-release. Idempotent — re-setting an already-granted region updates its note. `created_by` is taken from the caller\'s own authenticated identity, not the request body. Requires a Neo4j employee Okta token.
   * Grant an organization early access to one specific region.
   */
  async setRegionalPreReleaseRaw(
    requestParameters: SetRegionalPreReleaseOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<SetRegionalPreRelease200Response>> {
    if (requestParameters['organizationId'] == null) {
      throw new runtime.RequiredError(
        'organizationId',
        'Required parameter "organizationId" was null or undefined when calling setRegionalPreRelease().',
      );
    }

    if (requestParameters['cloudProvider'] == null) {
      throw new runtime.RequiredError(
        'cloudProvider',
        'Required parameter "cloudProvider" was null or undefined when calling setRegionalPreRelease().',
      );
    }

    if (requestParameters['regionId'] == null) {
      throw new runtime.RequiredError(
        'regionId',
        'Required parameter "regionId" was null or undefined when calling setRegionalPreRelease().',
      );
    }

    if (requestParameters['setRegionalPreReleaseRequest'] == null) {
      throw new runtime.RequiredError(
        'setRegionalPreReleaseRequest',
        'Required parameter "setRegionalPreReleaseRequest" was null or undefined when calling setRegionalPreRelease().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('BearerAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }

    let urlPath = `/v1/internal/admin/organizations/{organization_id}/regional-pre-release/{cloud_provider}/{region_id}`;
    urlPath = urlPath.replace(
      `{${'organization_id'}}`,
      encodeURIComponent(String(requestParameters['organizationId'])),
    );
    urlPath = urlPath.replace(
      `{${'cloud_provider'}}`,
      encodeURIComponent(String(requestParameters['cloudProvider'])),
    );
    urlPath = urlPath.replace(
      `{${'region_id'}}`,
      encodeURIComponent(String(requestParameters['regionId'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: SetRegionalPreReleaseRequestToJSON(
          requestParameters['setRegionalPreReleaseRequest'],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      SetRegionalPreRelease200ResponseFromJSON(jsonValue),
    );
  }

  /**
   * Per-region scope — the organization sees only this one region while it\'s pre-release. Idempotent — re-setting an already-granted region updates its note. `created_by` is taken from the caller\'s own authenticated identity, not the request body. Requires a Neo4j employee Okta token.
   * Grant an organization early access to one specific region.
   */
  async setRegionalPreRelease(
    requestParameters: SetRegionalPreReleaseOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<SetRegionalPreRelease200Response> {
    const response = await this.setRegionalPreReleaseRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
